import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { StatusBar, Style } from '@capacitor/status-bar';
import { Keyboard } from '@capacitor/keyboard';
import { startNativeAppLinkHandling } from '../lib/nativeApp';
import { applyNativeDocumentClass, hideNativeSplash, isNativePlatform } from '../lib/runtime';

/** Capacitor shell: deep links, status bar, keyboard — no-op on web. */
export function NativeAppBootstrap() {
  const navigate = useNavigate();

  useEffect(() => {
    applyNativeDocumentClass();

    let removeLinks: (() => void) | undefined;
    let cancelled = false;

    startNativeAppLinkHandling((path) => {
      navigate(path, { replace: true });
    }).then((unsubscribe) => {
      if (cancelled) {
        unsubscribe();
        return;
      }
      removeLinks = unsubscribe;
    });

    (async () => {
      if (!isNativePlatform()) return;
      try {
        await hideNativeSplash();
      } catch {
        // splash plugin unavailable
      }
      try {
        await StatusBar.setStyle({ style: Style.Dark });
        await StatusBar.setBackgroundColor({ color: '#120709' });
      } catch {
        // plugin unavailable
      }
      try {
        await Keyboard.setAccessoryBarVisible({ isVisible: true });
      } catch {
        // optional
      }
    })();

    return () => {
      cancelled = true;
      removeLinks?.();
    };
  }, [navigate]);

  return null;
}
